import {useCallback, useEffect, useState} from "react";
import {HttpMethod, initFetch} from "../utils/fetcher";

const RentalIncomesExpenses = (year) => {
  const [data, setData] = useState({incomes:[], expenses:[], years:[]});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRentalIncomesExpenses = useCallback(async () => {

    setLoading(true);
    setError(null);

    try {
      const {url, params} = initFetch(`rental-income/${year}`, HttpMethod.GET);
      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(`Erreur returned ${response.message}`);
      }

      setData({
        years: result.years,
        incomes: result.incomes,
        expenses: result.expenses
      });

    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  },[year]);

  useEffect( () => {
    fetchRentalIncomesExpenses().then();
  },[fetchRentalIncomesExpenses])

  return {
    years: data.years,
    incomes: data.incomes,
    expenses: data.expenses ,
    loading,
    error,
    refetch: fetchRentalIncomesExpenses };
}

export default RentalIncomesExpenses;